import axios from 'axios';
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL
const mernDashApi = axios.create({baseURL: process.env.REACT_APP_BASE_URL});
mernDashApi.interceptors.request.use(function (config) {
  console.log('');
  const token = localStorage.getItem('token');

  if (token) {
    // console.log('Token Recieved Sent');
    config.headers.Authorization = `Bearer ${token}`;

  }

  return config;
});

export default mernDashApi;
